<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1 scroll-reveal">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-indigo-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-indigo-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Gestión de Devoluciones
          <span class="px-2 sm:px-3 py-0.5 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 text-xs sm:text-sm font-black rounded-lg border border-indigo-200 dark:border-indigo-800">
            {{ devoluciones.length }}
          </span>
        </h1>
        <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">Reembolsos, inventario y liquidaciones</p>
      </div>

      <div class="flex items-center gap-2 w-full sm:w-auto">
        <button @click="refreshDevoluciones" :disabled="cargando" class="px-3 sm:px-4 py-2 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-md flex items-center gap-2 border border-gray-200 dark:border-gray-600 disabled:opacity-50">
          <Icon :icon="cargando ? 'mdi:loading' : 'mdi:refresh'" :class="['text-base sm:text-lg', cargando && 'animate-spin']" />
          <span>Actualizar</span>
        </button>

        <button @click="irANueva" class="px-3 sm:px-6 py-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-lg shadow-green-200 dark:shadow-none flex items-center gap-2">
          <Icon icon="mdi:plus" class="text-base sm:text-xl" />
          <span class="hidden sm:inline">Nueva Devolución</span>
          <span class="sm:hidden">Nueva</span>
        </button>
      </div>
    </div>

    <!-- Panel de Filtros Compacto -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 mb-3 sm:mb-5 overflow-hidden animate-fadeInUp">
      <div class="p-3 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between bg-gray-50/50 dark:bg-gray-800/50">
        <div class="flex items-center gap-2">
          <Icon icon="mdi:filter-variant" class="text-blue-500 text-lg" />
          <h2 class="text-[10px] sm:text-xs font-bold text-gray-700 dark:text-white uppercase tracking-wider">Filtros de Búsqueda</h2>
          <span v-if="filtrosActivos" class="px-1.5 py-0.5 bg-blue-100 text-blue-600 text-[8px] sm:text-[9px] font-bold rounded uppercase">Activos</span>
        </div>
        <button @click="toggleFiltros" class="text-[9px] sm:text-[10px] font-bold text-blue-600 hover:text-blue-700 flex items-center gap-1 uppercase">
          <Icon :icon="mostrarFiltros ? 'mdi:chevron-up' : 'mdi:chevron-down'" class="text-base" />
          {{ mostrarFiltros ? 'Contraer' : 'Expandir' }}
        </button>
      </div>

      <div v-if="mostrarFiltros" class="p-3 sm:p-4 bg-white dark:bg-gray-800">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-12 gap-2 sm:gap-3">
          <!-- Buscar -->
          <div class="xl:col-span-3">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Buscar</label>
            <input v-model="filtro.busqueda" type="text" placeholder="Nro. devolución o cliente" class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-xs focus:border-blue-500 outline-none transition-all text-gray-900 dark:text-white placeholder-gray-400" @input="filtrarDevoluciones" />
          </div>

          <!-- Estado -->
          <div class="xl:col-span-2">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Estado</label>
            <select v-model="filtro.estado" class="w-full px-2 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-xs focus:border-blue-500 outline-none cursor-pointer text-gray-900 dark:text-white" @change="filtrarDevoluciones">
              <option value="">Todos</option>
              <option value="pendiente">Pendiente</option>
              <option value="aprobada">Aprobada</option>
              <option value="parcial">Parcial</option>
              <option value="completada">Completada</option>
              <option value="rechazada">Rechazada</option>
              <option value="anulada">Anulada</option>
            </select>
          </div>

          <!-- Tipo de Origen -->
          <div class="xl:col-span-3">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Tipo de Origen</label>
            <select v-model="filtro.tipo_origen" class="w-full px-2 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-xs focus:border-blue-500 outline-none cursor-pointer text-gray-900 dark:text-white" @change="filtrarDevoluciones">
              <option value="">Todos</option>
              <option value="venta">🛒 Venta</option>
              <option value="servicio_externo">🔧 Servicio Externo</option>
              <option value="credito_salida_equipo">📦 Crédito Equipo</option>
              <option value="prestamo">💵 Préstamo</option>
              <option value="compra">🏭 Compra</option>
              <option value="retencion">📄 Retención</option>
            </select>
          </div>

          <!-- Rango de Fecha -->
          <div class="sm:col-span-2 xl:col-span-4">
            <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Rango de Fecha</label>
            <div class="flex items-center gap-1">
              <input v-model="filtro.fecha_desde" type="date" class="w-full min-w-0 px-2 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-[10px] focus:border-blue-500 outline-none text-gray-900 dark:text-white" @change="filtrarDevoluciones" />
              <span class="text-gray-300 text-xs px-0.5">-</span>
              <input v-model="filtro.fecha_hasta" type="date" class="w-full min-w-0 px-2 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-[10px] focus:border-blue-500 outline-none text-gray-900 dark:text-white" @change="filtrarDevoluciones" />
            </div>
          </div>

          <!-- Botones Limpiar / Aplicar en fila aparte para que no se encimen -->
          <div class="sm:col-span-2 xl:col-span-12 flex items-end justify-end gap-2 pt-1 xl:pt-0">
            <button @click="limpiarFiltros" class="px-4 py-2 text-[9px] sm:text-[10px] font-black uppercase text-gray-400 hover:text-gray-600 transition-colors border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
              <Icon icon="mdi:broom" class="text-sm" />
              Limpiar
            </button>
            <button @click="aplicarFiltrosRapidos" class="px-4 py-2 bg-blue-600 text-white rounded-lg text-[9px] sm:text-[10px] font-black uppercase shadow-md hover:bg-blue-700 transition-all flex items-center justify-center gap-1.5">
              <Icon icon="mdi:filter-check" class="text-sm" />
              Aplicar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Estadísticas rápidas -->
    <div v-if="estadisticas" class="grid grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4 mb-3 sm:mb-5 animate-fadeInUp">
      <div class="bg-white dark:bg-gray-800 rounded-2xl p-3 sm:p-4 shadow-sm border border-gray-200 dark:border-gray-700 flex items-center gap-3">
        <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center text-lg sm:text-2xl flex-shrink-0">⏳</div>
        <div>
          <span class="text-base sm:text-xl font-black text-gray-800 dark:text-white block leading-tight">{{ estadisticas.devolucionesPendientes || 0 }}</span>
          <span class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">Pendientes</span>
        </div>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-2xl p-3 sm:p-4 shadow-sm border border-gray-200 dark:border-gray-700 flex items-center gap-3">
        <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center text-lg sm:text-2xl flex-shrink-0">✅</div>
        <div>
          <span class="text-base sm:text-xl font-black text-gray-800 dark:text-white block leading-tight">{{ estadisticas.devolucionesAprobadas || 0 }}</span>
          <span class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">Aprobadas</span>
        </div>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-2xl p-3 sm:p-4 shadow-sm border border-gray-200 dark:border-gray-700 flex items-center gap-3">
        <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center text-lg sm:text-2xl flex-shrink-0">🎉</div>
        <div>
          <span class="text-base sm:text-xl font-black text-gray-800 dark:text-white block leading-tight">{{ estadisticas.devolucionesCompletadas || 0 }}</span>
          <span class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">Completadas</span>
        </div>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-2xl p-3 sm:p-4 shadow-sm border border-gray-200 dark:border-gray-700 flex items-center gap-3">
        <div class="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-lg sm:text-2xl flex-shrink-0">💵</div>
        <div>
          <span class="text-base sm:text-xl font-black text-gray-800 dark:text-white block leading-tight">${{ formatMoney(estadisticas.totalReembolsadoUsd) }}</span>
          <span class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">Reembolsado</span>
        </div>
      </div>
    </div>

    <!-- Tabla -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden animate-fadeInUp delay-100">
      <!-- Vista móvil (cards) -->
      <div class="block sm:hidden">
        <div v-if="cargando" class="p-8 text-center">
          <div class="inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-500 border-t-transparent"></div>
          <p class="mt-2 text-gray-600 dark:text-gray-400 text-sm">Cargando devoluciones...</p>
        </div>

        <div v-else-if="devolucionesPaginadas.length === 0" class="p-8 text-center">
          <Icon icon="mdi:file-search-outline" class="text-5xl text-gray-300 mx-auto mb-3" />
          <p class="text-gray-600 dark:text-gray-400 font-bold">No hay devoluciones</p>
          <button @click="limpiarFiltros" class="mt-2 text-indigo-600 text-sm hover:underline font-bold">Limpiar filtros</button>
        </div>

        <div v-else class="divide-y divide-gray-200 dark:divide-gray-700">
          <div v-for="dev in devolucionesPaginadas" :key="dev.idDevolucion" class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
            <div class="flex justify-between items-start mb-2">
              <div class="flex-1 min-w-0">
                <div class="font-bold text-blue-600 dark:text-blue-400 truncate flex items-center gap-2 text-sm">
                  {{ dev.numero_devolucion }}
                  <span class="px-2 py-0.5 text-[8px] rounded-full whitespace-nowrap font-black bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300 uppercase">
                    {{ formatTipoOrigen(dev.tipo_origen) }}
                  </span>
                </div>
                <div class="text-[10px] text-gray-500 dark:text-gray-400 font-bold">{{ formatDate(dev.fecha_devolucion) }}</div>
              </div>
              <span class="badge-estado" :class="`estado-${dev.estado}`">{{ formatEstado(dev.estado) }}</span>
            </div>

            <div class="grid grid-cols-2 gap-2 mb-2 text-xs">
              <div>
                <span class="text-[9px] text-gray-500 dark:text-gray-400 block uppercase font-bold">Cliente/Proveedor</span>
                <span class="font-bold truncate block text-gray-800 dark:text-white">{{ truncarTexto(dev.cliente_nombre || dev.proveedor_nombre || '—', 20) }}</span>
              </div>
              <div>
                <span class="text-[9px] text-gray-500 dark:text-gray-400 block uppercase font-bold">Motivo</span>
                <span class="font-bold truncate block text-gray-800 dark:text-white">{{ formatMotivo(dev.motivo) }}</span>
              </div>
            </div>

            <div class="flex justify-between items-center">
              <div class="text-right">
                <div class="font-black text-base text-gray-800 dark:text-white">${{ formatMoney(dev.total_usd) }}</div>
                <div v-if="dev.saldo_pendiente_usd > 0" class="text-[9px] font-black text-red-600 dark:text-red-400 uppercase">
                  Saldo: ${{ formatMoney(dev.saldo_pendiente_usd) }}
                </div>
              </div>
            </div>

            <div class="flex justify-end gap-1 mt-3 pt-2 border-t border-gray-100 dark:border-gray-700">
              <button @click="verDetalle(dev)" class="p-1.5 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded-lg transition-colors" title="Ver detalle">
                <Icon icon="mdi:eye-outline" class="text-base" />
              </button>
              <button v-if="dev.estado === 'pendiente'" @click="aprobar(dev)" class="p-1.5 text-green-600 hover:bg-green-50 dark:hover:bg-green-900/20 rounded-lg transition-colors" title="Aprobar">
                <Icon icon="mdi:check-circle-outline" class="text-base" />
              </button>
              <button v-if="dev.estado === 'pendiente'" @click="abrirModalRechazo(dev)" class="p-1.5 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors" title="Rechazar">
                <Icon icon="mdi:close-circle-outline" class="text-base" />
              </button>
              <button v-if="puedeReingresarInventario(dev)" @click="reingresarInventario(dev)" class="p-1.5 text-orange-600 hover:bg-orange-50 dark:hover:bg-orange-900/20 rounded-lg transition-colors" title="Reingresar inventario">
                <Icon icon="mdi:package-variant" class="text-base" />
              </button>
              <button v-if="puedeRegistrarPago(dev)" @click="abrirModalPago(dev)" class="p-1.5 text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 rounded-lg transition-colors" title="Registrar pago">
                <Icon icon="mdi:cash-plus" class="text-base" />
              </button>
              <button v-if="puedeCompletar(dev)" @click="completarDevolucion(dev)" class="p-1.5 text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-900/20 rounded-lg transition-colors" title="Completar">
                <Icon icon="mdi:check-decagram" class="text-base" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista desktop (tabla) -->
      <div class="hidden sm:block overflow-x-auto custom-scrollbar">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Número</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Tipo Origen</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Cliente/Proveedor</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Motivo</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Fecha</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Total USD</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Saldo Pend.</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest">Estado</th>
              <th class="px-5 py-4 text-[11px] font-black text-gray-400 tracking-widest text-center">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            <tr v-if="cargando" v-for="i in 5" :key="'load-'+i" class="animate-pulse">
              <td colspan="9" class="px-5 py-4"><div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full"></div></td>
            </tr>
            <tr v-if="!cargando && devolucionesFiltradas.length === 0">
              <td colspan="9" class="px-5 py-16 text-center">
                <div class="flex flex-col items-center opacity-30 select-none">
                  <Icon icon="mdi:file-search-outline" class="text-7xl mb-3" />
                  <h4 class="text-xl font-black text-gray-400 tracking-widest">No hay devoluciones</h4>
                </div>
              </td>
            </tr>
            <tr v-for="dev in devolucionesPaginadas" :key="dev.idDevolucion"
                @click="verDetalle(dev)"
                class="hover:bg-indigo-50/30 dark:hover:bg-gray-700/30 transition-all cursor-pointer">
              <td class="px-5 py-4">
                <div class="font-bold text-gray-900 dark:text-white text-sm">{{ dev.numero_devolucion }}</div>
              </td>
              <td class="px-5 py-4">
                <span class="px-2.5 py-1 text-[9px] rounded-full font-black uppercase bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300">
                  {{ formatTipoOrigen(dev.tipo_origen) }}
                </span>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center gap-2">
                  <div class="w-7 h-7 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center font-black text-gray-500 text-xs">
                    {{ (dev.cliente_nombre || dev.proveedor_nombre || '?').charAt(0) }}
                  </div>
                  <span class="font-bold text-gray-900 dark:text-white text-xs truncate max-w-[150px]">
                    {{ truncarTexto(dev.cliente_nombre || dev.proveedor_nombre || '—', 25) }}
                  </span>
                </div>
              </td>
              <td class="px-5 py-4">
                <span class="text-xs font-bold text-gray-600 dark:text-gray-300">{{ formatMotivo(dev.motivo) }}</span>
              </td>
              <td class="px-5 py-4">
                <span class="text-xs font-bold text-gray-600 dark:text-gray-300">{{ formatDate(dev.fecha_devolucion) }}</span>
              </td>
              <td class="px-5 py-4">
                <div class="font-black text-gray-900 dark:text-white text-sm">${{ formatMoney(dev.total_usd) }}</div>
              </td>
              <td class="px-5 py-4">
                <div :class="['font-black text-sm', dev.saldo_pendiente_usd > 0 ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400']">
                  ${{ formatMoney(dev.saldo_pendiente_usd) }}
                </div>
              </td>
              <td class="px-5 py-4">
                <span class="badge-estado" :class="`estado-${dev.estado}`">{{ formatEstado(dev.estado) }}</span>
              </td>
              <td class="px-5 py-4">
                <div class="flex items-center justify-center gap-0.5 flex-nowrap whitespace-nowrap">
                  <button @click.stop="verDetalle(dev)" class="p-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg hover:bg-blue-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Ver detalle">
                    <Icon icon="mdi:eye-outline" class="text-base" />
                  </button>
                  <button v-if="dev.estado === 'pendiente'" @click.stop="aprobar(dev)" class="p-1.5 bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-lg hover:bg-green-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Aprobar">
                    <Icon icon="mdi:check-circle-outline" class="text-base" />
                  </button>
                  <button v-if="dev.estado === 'pendiente'" @click.stop="abrirModalRechazo(dev)" class="p-1.5 bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Rechazar">
                    <Icon icon="mdi:close-circle-outline" class="text-base" />
                  </button>
                  <button v-if="puedeReingresarInventario(dev)" @click.stop="reingresarInventario(dev)" class="p-1.5 bg-orange-50 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 rounded-lg hover:bg-orange-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Reingresar inventario">
                    <Icon icon="mdi:package-variant" class="text-base" />
                  </button>
                  <span v-if="dev.inventario_reingresado" class="p-1.5 bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-400 rounded-lg flex-shrink-0" title="Inventario ya reingresado">
                    <Icon icon="mdi:package-variant-closed-check" class="text-base" />
                  </span>
                  <button v-if="puedeRegistrarPago(dev)" @click.stop="abrirModalPago(dev)" class="p-1.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 rounded-lg hover:bg-emerald-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Registrar pago">
                    <Icon icon="mdi:cash-plus" class="text-base" />
                  </button>
                  <button v-if="puedeCompletar(dev)" @click.stop="completarDevolucion(dev)" class="p-1.5 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 rounded-lg hover:bg-indigo-600 hover:text-white transition-all shadow-sm flex-shrink-0" title="Completar devolución">
                    <Icon icon="mdi:check-decagram" class="text-base" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación Premium -->
      <div v-if="devolucionesFiltradas.length > itemsPorPagina" class="bg-gray-50/50 dark:bg-gray-800/50 px-3 sm:px-5 py-3 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div class="text-[9px] sm:text-[11px] font-black text-gray-400 uppercase tracking-widest text-center sm:text-left">
          Mostrando {{ startIndex + 1 }} - {{ Math.min(endIndex, devolucionesFiltradas.length) }} <span class="mx-1 text-gray-300">|</span> Total: {{ devolucionesFiltradas.length }}
        </div>
        <div class="flex items-center gap-1 flex-wrap justify-center">
          <!-- Primera página << -->
          <button @click="goToFirstPage" :disabled="paginaActual === 1" :class="['w-7 h-7 sm:w-9 sm:h-9 rounded-lg border transition-all flex items-center justify-center', paginaActual === 1 ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm text-gray-500']">
            <Icon icon="mdi:chevron-double-left" class="text-sm sm:text-lg" />
          </button>

          <!-- Anterior < -->
          <button @click="paginaAnterior" :disabled="paginaActual === 1" :class="['w-7 h-7 sm:w-9 sm:h-9 rounded-lg border transition-all flex items-center justify-center', paginaActual === 1 ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm text-gray-500']">
            <Icon icon="mdi:chevron-left" class="text-sm sm:text-lg" />
          </button>

          <!-- Números -->
          <div class="hidden sm:flex items-center gap-0.5 sm:gap-1 mx-1 sm:mx-2">
            <button v-for="page in paginasVisibles" :key="page" @click="irAPagina(page)" :class="['w-7 h-7 sm:w-9 sm:h-9 rounded-lg text-[10px] sm:text-xs font-black transition-all flex items-center justify-center', paginaActual === page ? 'bg-indigo-600 text-white shadow-md shadow-indigo-500/30' : 'text-gray-500 hover:bg-white dark:hover:bg-gray-700 border border-transparent hover:border-gray-200 dark:hover:border-gray-600']">
              {{ page }}
            </button>
          </div>
          <span class="sm:hidden text-xs font-black text-gray-600 dark:text-gray-300 px-2">{{ paginaActual }} / {{ totalPaginas }}</span>

          <!-- Siguiente > -->
          <button @click="paginaSiguiente" :disabled="paginaActual === totalPaginas" :class="['w-7 h-7 sm:w-9 sm:h-9 rounded-lg border transition-all flex items-center justify-center', paginaActual === totalPaginas ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm text-gray-500']">
            <Icon icon="mdi:chevron-right" class="text-sm sm:text-lg" />
          </button>

          <!-- Última página >> -->
          <button @click="goToLastPage" :disabled="paginaActual === totalPaginas" :class="['w-7 h-7 sm:w-9 sm:h-9 rounded-lg border transition-all flex items-center justify-center', paginaActual === totalPaginas ? 'opacity-30 cursor-not-allowed border-gray-200 dark:border-gray-700' : 'hover:bg-white dark:hover:bg-gray-700 border-gray-200 dark:border-gray-600 shadow-sm text-gray-500']">
            <Icon icon="mdi:chevron-double-right" class="text-sm sm:text-lg" />
          </button>
        </div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- MODAL DE PAGO -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="modalPago.show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[9999]" @click.self="cerrarModalPago">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-zoomIn max-h-[95vh] flex flex-col">
          <div class="bg-gradient-to-r from-green-600 to-emerald-600 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between flex-shrink-0">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl">
                <Icon icon="mdi:cash-plus" class="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">Registrar Pago</h3>
                <p class="text-[8px] sm:text-[10px] text-green-100 font-bold">Registrar reembolso al cliente</p>
              </div>
            </div>
            <button @click="cerrarModalPago" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg sm:text-xl" />
            </button>
          </div>

          <div class="p-4 sm:p-6 overflow-y-auto custom-scrollbar">
            <div class="bg-gray-50 dark:bg-gray-700/30 p-3 rounded-xl border border-gray-100 dark:border-gray-700 text-left mb-4">
              <div class="flex justify-between text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1">
                <span>Devolución</span>
                <span class="text-gray-800 dark:text-white font-black text-xs sm:text-sm">{{ modalPago.devolucion?.numero_devolucion }}</span>
              </div>
              <div class="flex justify-between text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">
                <span>Saldo Pendiente</span>
                <span class="text-red-600 text-sm sm:text-base font-black">${{ formatMoney(modalPago.devolucion?.saldo_pendiente_usd) }}</span>
              </div>
            </div>

            <div class="space-y-3">
              <div>
                <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Monto USD</label>
                <input v-model.number="modalPago.monto_usd" type="number" step="0.01" placeholder="0.00" class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:border-green-500 outline-none text-gray-900 dark:text-white" />
              </div>
              <div>
                <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Monto Bs</label>
                <input v-model.number="modalPago.monto_bs" type="number" step="0.01" placeholder="0.00" class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:border-green-500 outline-none text-gray-900 dark:text-white" />
              </div>
              <div>
                <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Tasa Bs/USD</label>
                <input v-model.number="modalPago.tasa_bs_usd" type="number" step="0.01" placeholder="0.00" class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:border-green-500 outline-none text-gray-900 dark:text-white" />
              </div>
              <div>
                <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Método de Pago</label>
                <select v-model="modalPago.metodo_pago" class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:border-green-500 outline-none cursor-pointer text-gray-900 dark:text-white">
                  <option value="efectivo">💵 Efectivo</option>
                  <option value="transferencia">🏦 Transferencia</option>
                  <option value="pago_movil">📱 Pago Móvil</option>
                  <option value="zelle">💰 Zelle</option>
                  <option value="usdt">🪙 USDT</option>
                  <option value="credito_cuenta">💳 Crédito en Cuenta</option>
                  <option value="nota_credito">📄 Nota de Crédito</option>
                </select>
              </div>
              <div>
                <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Referencia (opcional)</label>
                <input v-model="modalPago.referencia" type="text" placeholder="Nro. referencia" class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:border-green-500 outline-none text-gray-900 dark:text-white" />
              </div>
              <div>
                <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Observaciones</label>
                <textarea v-model="modalPago.observaciones" rows="2" class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:border-green-500 outline-none text-gray-900 dark:text-white resize-none"></textarea>
              </div>
            </div>
          </div>

          <div class="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 flex flex-col sm:flex-row gap-2 flex-shrink-0">
            <button @click="cerrarModalPago" class="w-full sm:flex-1 px-4 py-2 text-[10px] sm:text-xs font-black text-gray-400 uppercase border border-gray-100 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all">Cancelar</button>
            <button @click="guardarPago" :disabled="procesando" class="w-full sm:flex-1 px-4 py-2 bg-green-600 text-white rounded-lg text-[10px] sm:text-xs font-black uppercase shadow-md hover:bg-green-700 disabled:opacity-50 transition-all flex items-center justify-center gap-2">
              <Icon v-if="procesando" icon="mdi:loading" class="animate-spin" />
              {{ procesando ? 'Guardando...' : 'Registrar Pago' }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE RECHAZO -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="modalRechazo.show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[10000]" @click.self="cerrarModalRechazo">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-zoomIn">
          <div class="bg-gradient-to-r from-red-600 to-rose-600 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl">
                <Icon icon="mdi:alert-circle" class="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">Rechazar Devolución</h3>
                <p class="text-[8px] sm:text-[10px] text-red-100 font-bold">Indica el motivo del rechazo</p>
              </div>
            </div>
            <button @click="cerrarModalRechazo" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg sm:text-xl" />
            </button>
          </div>

          <div class="p-4 sm:p-6">
            <div class="bg-red-50/30 dark:bg-red-900/10 p-3 rounded-xl border border-red-100 dark:border-red-900/30 text-left mb-4">
              <div class="flex justify-between text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1">
                <span>Devolución</span>
                <span class="text-gray-800 dark:text-white font-black text-xs sm:text-sm">{{ modalRechazo.devolucion?.numero_devolucion }}</span>
              </div>
              <div class="flex justify-between text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase">
                <span>Cliente</span>
                <span class="text-gray-800 dark:text-white font-black text-xs">{{ modalRechazo.devolucion?.cliente_nombre || '—' }}</span>
              </div>
            </div>

            <div>
              <label class="block text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase mb-1 ml-1">Motivo del rechazo *</label>
              <textarea v-model="modalRechazo.motivo" rows="3" placeholder="Explica por qué se rechaza..." class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700/50 border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:border-red-500 outline-none text-gray-900 dark:text-white resize-none"></textarea>
            </div>
          </div>

          <div class="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 flex flex-col sm:flex-row gap-2">
            <button @click="cerrarModalRechazo" class="w-full sm:flex-1 px-4 py-2 text-[10px] sm:text-xs font-black text-gray-400 uppercase border border-gray-100 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all">Cancelar</button>
            <button @click="confirmarRechazo" :disabled="procesando || !modalRechazo.motivo.trim()" class="w-full sm:flex-1 px-4 py-2 bg-red-600 text-white rounded-lg text-[10px] sm:text-xs font-black uppercase shadow-md hover:bg-red-700 disabled:opacity-50 transition-all flex items-center justify-center gap-2">
              <Icon v-if="procesando" icon="mdi:loading" class="animate-spin" />
              {{ procesando ? 'Rechazando...' : 'Confirmar Rechazo' }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- MODAL DE CONFIRMACIÓN (Aprobar / Inventario / Completar) -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="modalConfirm.show" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[10001]" @click.self="cerrarConfirm">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-zoomIn">
          <div :class="['px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between', modalConfirm.headerClass]">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl">
                <Icon :icon="modalConfirm.icon" class="text-white text-lg sm:text-xl" />
              </div>
              <div>
                <h3 class="text-sm sm:text-base font-bold text-white uppercase tracking-wider">{{ modalConfirm.titulo }}</h3>
                <p :class="['text-[8px] sm:text-[10px] font-bold', modalConfirm.subtitleClass]">{{ modalConfirm.subtitulo }}</p>
              </div>
            </div>
            <button @click="cerrarConfirm" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg sm:text-xl" />
            </button>
          </div>

          <div class="p-4 sm:p-6">
            <div :class="['p-3 sm:p-4 rounded-xl border text-center mb-4', modalConfirm.boxClass]">
              <p :class="['text-[9px] sm:text-[10px] font-bold uppercase mb-1', modalConfirm.boxTitleClass]">{{ modalConfirm.mensaje }}</p>
              <p class="text-sm sm:text-base font-black text-gray-800 dark:text-white">{{ modalConfirm.detalle }}</p>
            </div>

            <div class="flex flex-col sm:flex-row gap-2">
              <button @click="cerrarConfirm" class="w-full sm:flex-1 px-4 py-2 text-[10px] sm:text-xs font-black text-gray-400 uppercase border border-gray-100 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-all">Cancelar</button>
              <button @click="confirmarAccion" :disabled="procesando" :class="['w-full sm:flex-1 px-4 py-2 text-white rounded-lg text-[10px] sm:text-xs font-black uppercase shadow-md transition-all flex items-center justify-center gap-2', modalConfirm.btnClass]">
                <Icon v-if="procesando" icon="mdi:loading" class="animate-spin" />
                {{ procesando ? 'Procesando...' : modalConfirm.confirmText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- ============================================ -->
    <!-- TOASTS PROFESIONALES -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div class="fixed top-4 right-4 z-[999999] flex flex-col gap-3 pointer-events-none max-w-sm w-full px-2">
        <TransitionGroup
          enter-active-class="transition-all duration-300 ease-out"
          enter-from-class="opacity-0 translate-x-full scale-95"
          enter-to-class="opacity-100 translate-x-0 scale-100"
          leave-active-class="transition-all duration-300 ease-in absolute"
          leave-from-class="opacity-100 translate-x-0 scale-100"
          leave-to-class="opacity-0 translate-x-full scale-95"
          move-class="transition-all duration-300"
        >
          <div
            v-for="toast in toasts"
            :key="toast.id"
            class="pointer-events-auto relative overflow-hidden rounded-2xl shadow-2xl backdrop-blur-xl border w-full"
            :class="getToastClasses(toast.type)"
          >
            <div class="absolute bottom-0 left-0 h-1 rounded-full" :class="getToastProgressClass(toast.type)" :style="{ animation: `toastProgress ${toast.duration}ms linear forwards` }"></div>

            <div class="flex items-start gap-3 p-4">
              <div class="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center shadow-sm" :class="getToastIconBg(toast.type)">
                <Icon :icon="getToastIcon(toast.type)" class="text-2xl animate-toastIcon" :class="getToastIconColor(toast.type)" />
              </div>

              <div class="flex-1 min-w-0">
                <p class="font-bold text-sm" :class="getToastTitleColor(toast.type)">{{ toast.title }}</p>
                <p v-if="toast.message" class="text-xs mt-0.5 leading-relaxed" :class="getToastMessageColor(toast.type)">{{ toast.message }}</p>
              </div>

              <button @click="cerrarToast(toast.id)" class="flex-shrink-0 p-1 rounded-lg transition-all hover:scale-110" :class="getToastCloseClass(toast.type)">
                <Icon icon="mdi:close" class="text-base" />
              </button>
            </div>
          </div>
        </TransitionGroup>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Icon } from '@iconify/vue';
import { getCurrentUser } from '@/api/index';
import {
  obtenerDevoluciones,
  obtenerEstadisticasDevoluciones,
  aprobarDevolucion,
  rechazarDevolucion,
  registrarPagoDevolucion,
  reingresarInventarioDevolucion,
  completarDevolucion as completarDevolucionApi
} from '@/api/devoluciones';

const router = useRouter();
const usuario = getCurrentUser();

const devoluciones = ref([]);
const estadisticas = ref(null);
const cargando = ref(false);
const procesando = ref(false);

const mostrarFiltros = ref(true);
const paginaActual = ref(1);
const itemsPorPagina = ref(10);

// ⭐ TOASTS
const toasts = ref([]);
let toastIdCounter = 0;

const mostrarToast = (type, title, message = '', duration = 4000) => {
  const id = ++toastIdCounter;
  toasts.value.push({ id, type, title, message, duration });
  setTimeout(() => cerrarToast(id), duration);
};

const cerrarToast = (id) => {
  const index = toasts.value.findIndex(t => t.id === id);
  if (index !== -1) toasts.value.splice(index, 1);
};

const toastSuccess = (t, m = '') => mostrarToast('success', t, m, 4000);
const toastError = (t, m = '') => mostrarToast('error', t, m, 5000);
const toastWarning = (t, m = '') => mostrarToast('warning', t, m, 4500);
const toastInfo = (t, m = '') => mostrarToast('info', t, m, 4000);

const getToastClasses = (type) => ({
  success: 'bg-white/95 dark:bg-gray-800/95 border-emerald-200 dark:border-emerald-800/60',
  error: 'bg-white/95 dark:bg-gray-800/95 border-red-200 dark:border-red-800/60',
  warning: 'bg-white/95 dark:bg-gray-800/95 border-amber-200 dark:border-amber-800/60',
  info: 'bg-white/95 dark:bg-gray-800/95 border-blue-200 dark:border-blue-800/60'
}[type] || 'bg-white/95 dark:bg-gray-800/95 border-blue-200');

const getToastProgressClass = (type) => ({
  success: 'bg-gradient-to-r from-emerald-400 to-green-500',
  error: 'bg-gradient-to-r from-red-400 to-rose-500',
  warning: 'bg-gradient-to-r from-amber-400 to-orange-500',
  info: 'bg-gradient-to-r from-blue-400 to-indigo-500'
}[type] || 'bg-gradient-to-r from-blue-400 to-indigo-500');

const getToastIconBg = (type) => ({
  success: 'bg-gradient-to-br from-emerald-100 to-green-100 dark:from-emerald-900/40 dark:to-green-900/40',
  error: 'bg-gradient-to-br from-red-100 to-rose-100 dark:from-red-900/40 dark:to-rose-900/40',
  warning: 'bg-gradient-to-br from-amber-100 to-orange-100 dark:from-amber-900/40 dark:to-orange-900/40',
  info: 'bg-gradient-to-br from-blue-100 to-indigo-100 dark:from-blue-900/40 dark:to-indigo-900/40'
}[type] || '');

const getToastIcon = (type) => ({
  success: 'mdi:check-circle',
  error: 'mdi:alert-circle',
  warning: 'mdi:alert',
  info: 'mdi:information'
}[type] || 'mdi:information');

const getToastIconColor = (type) => ({
  success: 'text-emerald-600 dark:text-emerald-400',
  error: 'text-red-600 dark:text-red-400',
  warning: 'text-amber-600 dark:text-amber-400',
  info: 'text-blue-600 dark:text-blue-400'
}[type] || '');

const getToastTitleColor = (type) => ({
  success: 'text-emerald-900 dark:text-emerald-100',
  error: 'text-red-900 dark:text-red-100',
  warning: 'text-amber-900 dark:text-amber-100',
  info: 'text-blue-900 dark:text-blue-100'
}[type] || '');

const getToastMessageColor = (type) => ({
  success: 'text-emerald-700 dark:text-emerald-300',
  error: 'text-red-700 dark:text-red-300',
  warning: 'text-amber-700 dark:text-amber-300',
  info: 'text-blue-700 dark:text-blue-300'
}[type] || '');

const getToastCloseClass = (type) => ({
  success: 'text-emerald-500 hover:bg-emerald-100 dark:hover:bg-emerald-900/30',
  error: 'text-red-500 hover:bg-red-100 dark:hover:bg-red-900/30',
  warning: 'text-amber-500 hover:bg-amber-100 dark:hover:bg-amber-900/30',
  info: 'text-blue-500 hover:bg-blue-100 dark:hover:bg-blue-900/30'
}[type] || '');

// ⭐ Filtros
const filtro = ref({
  busqueda: '',
  estado: '',
  tipo_origen: '',
  fecha_desde: '',
  fecha_hasta: ''
});

const filtrosActivos = computed(() => filtro.value.busqueda || filtro.value.estado || filtro.value.tipo_origen || filtro.value.fecha_desde || filtro.value.fecha_hasta);

// ⭐ Modales
const modalPago = ref({
  show: false,
  devolucion: null,
  monto_usd: 0,
  monto_bs: 0,
  tasa_bs_usd: 0,
  metodo_pago: 'efectivo',
  referencia: '',
  observaciones: ''
});

const modalRechazo = ref({
  show: false,
  devolucion: null,
  motivo: ''
});

const modalConfirm = ref({
  show: false,
  titulo: '',
  subtitulo: '',
  mensaje: '',
  detalle: '',
  icon: 'mdi:help-circle',
  headerClass: 'bg-gradient-to-r from-blue-600 to-indigo-600',
  subtitleClass: 'text-blue-100',
  boxClass: 'bg-blue-50/30 dark:bg-blue-900/10 border-blue-100 dark:border-blue-900/30',
  boxTitleClass: 'text-blue-700 dark:text-blue-400',
  btnClass: 'bg-blue-600 hover:bg-blue-700',
  confirmText: 'Confirmar',
  onConfirm: null
});

// =====================================================
// COMPUTED
// =====================================================
const devolucionesFiltradas = computed(() => {
  let lista = [...devoluciones.value];

  if (filtro.value.busqueda) {
    const q = filtro.value.busqueda.toLowerCase();
    lista = lista.filter(d =>
      d.numero_devolucion?.toLowerCase().includes(q) ||
      d.cliente_nombre?.toLowerCase().includes(q) ||
      d.proveedor_nombre?.toLowerCase().includes(q)
    );
  }
  if (filtro.value.estado) lista = lista.filter(d => d.estado === filtro.value.estado);
  if (filtro.value.tipo_origen) lista = lista.filter(d => d.tipo_origen === filtro.value.tipo_origen);
  if (filtro.value.fecha_desde) lista = lista.filter(d => new Date(d.fecha_devolucion) >= new Date(filtro.value.fecha_desde));
  if (filtro.value.fecha_hasta) lista = lista.filter(d => new Date(d.fecha_devolucion) <= new Date(filtro.value.fecha_hasta + 'T23:59:59'));

  return lista;
});

const totalPaginas = computed(() => Math.ceil(devolucionesFiltradas.value.length / itemsPorPagina.value));

const devolucionesPaginadas = computed(() => {
  const start = (paginaActual.value - 1) * itemsPorPagina.value;
  return devolucionesFiltradas.value.slice(start, start + itemsPorPagina.value);
});

const startIndex = computed(() => (paginaActual.value - 1) * itemsPorPagina.value);
const endIndex = computed(() => Math.min(startIndex.value + itemsPorPagina.value, devolucionesFiltradas.value.length));

const paginasVisibles = computed(() => {
  const total = totalPaginas.value;
  const current = paginaActual.value;
  if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
  if (current <= 3) return [1, 2, 3, 4, 5];
  if (current >= total - 2) return [total - 4, total - 3, total - 2, total - 1, total];
  return [current - 2, current - 1, current, current + 1, current + 2];
});

const puedeReingresarInventario = (dev) => {
  if (!['aprobada', 'parcial'].includes(dev.estado)) return false;
  if (!dev.afecta_inventario) return false;
  if (dev.inventario_reingresado === true) return false;
  return true;
};

const puedeRegistrarPago = (dev) => {
  if (!['aprobada', 'parcial'].includes(dev.estado)) return false;
  if ((dev.saldo_pendiente_usd || 0) <= 0.01) return false;
  return true;
};

const puedeCompletar = (dev) => {
  if (!['aprobada', 'parcial'].includes(dev.estado)) return false;
  if (dev.afecta_inventario && dev.inventario_reingresado !== true) return false;
  if ((dev.saldo_pendiente_usd || 0) > 0.01) return false;
  return true;
};

// =====================================================
// MODAL CONFIRM
// =====================================================
const abrirConfirm = ({ titulo, subtitulo = '', mensaje, detalle, icon, headerClass, subtitleClass, boxClass, boxTitleClass, btnClass, confirmText = 'Confirmar', onConfirm }) => {
  modalConfirm.value = {
    show: true, titulo, subtitulo, mensaje, detalle, icon,
    headerClass, subtitleClass, boxClass, boxTitleClass, btnClass, confirmText, onConfirm
  };
};

const cerrarConfirm = () => {
  modalConfirm.value.show = false;
};

const confirmarAccion = async () => {
  if (modalConfirm.value.onConfirm) await modalConfirm.value.onConfirm();
  cerrarConfirm();
};

// =====================================================
// MÉTODOS
// =====================================================
const toggleFiltros = () => { mostrarFiltros.value = !mostrarFiltros.value; };

const cargarDevoluciones = async () => {
  cargando.value = true;
  try {
    devoluciones.value = await obtenerDevoluciones();
    paginaActual.value = 1;
  } catch (error) {
    console.error(error);
    toastError('Error al cargar', 'No se pudieron obtener las devoluciones.');
  } finally {
    cargando.value = false;
  }
};

const cargarEstadisticas = async () => {
  try {
    estadisticas.value = await obtenerEstadisticasDevoluciones();
  } catch (error) {
    console.error(error);
  }
};

const refreshDevoluciones = async () => {
  if (cargando.value) return;
  await Promise.all([cargarDevoluciones(), cargarEstadisticas()]);
  toastSuccess('Lista actualizada', 'Datos recargados correctamente.');
};

const filtrarDevoluciones = () => { paginaActual.value = 1; };

const limpiarFiltros = () => {
  filtro.value = { busqueda: '', estado: '', tipo_origen: '', fecha_desde: '', fecha_hasta: '' };
  paginaActual.value = 1;
  toastInfo('Filtros limpiados', 'Se restablecieron todos los filtros.');
};

const aplicarFiltrosRapidos = () => {
  paginaActual.value = 1;
  mostrarFiltros.value = false;
  toastSuccess('Filtros aplicados', `${devolucionesFiltradas.value.length} resultados.`);
};

const goToFirstPage = () => { if (paginaActual.value > 1) { paginaActual.value = 1; window.scrollTo({ top: 0, behavior: 'smooth' }); } };
const goToLastPage = () => { if (paginaActual.value < totalPaginas.value) { paginaActual.value = totalPaginas.value; window.scrollTo({ top: 0, behavior: 'smooth' }); } };
const paginaAnterior = () => { if (paginaActual.value > 1) { paginaActual.value--; window.scrollTo({ top: 0, behavior: 'smooth' }); } };
const paginaSiguiente = () => { if (paginaActual.value < totalPaginas.value) { paginaActual.value++; window.scrollTo({ top: 0, behavior: 'smooth' }); } };
const irAPagina = (p) => { if (p >= 1 && p <= totalPaginas.value) { paginaActual.value = p; window.scrollTo({ top: 0, behavior: 'smooth' }); } };

const irANueva = () => router.push('/devoluciones/nueva');
const verDetalle = (dev) => router.push(`/devoluciones/${dev.idDevolucion}`);

const aprobar = (dev) => {
  abrirConfirm({
    titulo: 'Aprobar Devolución',
    subtitulo: 'Confirmar aprobación',
    mensaje: '¿Aprobar la devolución?',
    detalle: dev.numero_devolucion,
    icon: 'mdi:check-circle',
    headerClass: 'bg-gradient-to-r from-green-600 to-emerald-600',
    subtitleClass: 'text-green-100',
    boxClass: 'bg-green-50/30 dark:bg-green-900/10 border-green-100 dark:border-green-900/30',
    boxTitleClass: 'text-green-700 dark:text-green-400',
    btnClass: 'bg-green-600 hover:bg-green-700',
    confirmText: 'Sí, aprobar',
    onConfirm: async () => {
      procesando.value = true;
      try {
        await aprobarDevolucion(dev.idDevolucion, usuario?.idUsuario);
        await Promise.all([cargarDevoluciones(), cargarEstadisticas()]);
        toastSuccess('Devolución aprobada', dev.numero_devolucion);
      } catch (error) {
        toastError('Error al aprobar', error.message || 'No se pudo aprobar.');
      } finally { procesando.value = false; }
    }
  });
};

const abrirModalRechazo = (dev) => {
  modalRechazo.value = { show: true, devolucion: dev, motivo: '' };
};
const cerrarModalRechazo = () => { modalRechazo.value.show = false; };

const confirmarRechazo = async () => {
  if (!modalRechazo.value.motivo.trim()) {
    toastWarning('Motivo requerido', 'Debes explicar el motivo del rechazo.');
    return;
  }
  procesando.value = true;
  try {
    await rechazarDevolucion(modalRechazo.value.devolucion.idDevolucion, usuario?.idUsuario, modalRechazo.value.motivo.trim());
    await Promise.all([cargarDevoluciones(), cargarEstadisticas()]);
    toastWarning('Devolución rechazada', modalRechazo.value.devolucion.numero_devolucion);
    cerrarModalRechazo();
  } catch (error) {
    toastError('Error al rechazar', error.message || 'No se pudo rechazar.');
  } finally { procesando.value = false; }
};

const reingresarInventario = (dev) => {
  abrirConfirm({
    titulo: 'Reingresar al Inventario',
    subtitulo: 'Actualizar stock',
    mensaje: '¿Reingresar los productos?',
    detalle: dev.numero_devolucion,
    icon: 'mdi:package-variant',
    headerClass: 'bg-gradient-to-r from-orange-600 to-amber-600',
    subtitleClass: 'text-orange-100',
    boxClass: 'bg-orange-50/30 dark:bg-orange-900/10 border-orange-100 dark:border-orange-900/30',
    boxTitleClass: 'text-orange-700 dark:text-orange-400',
    btnClass: 'bg-orange-600 hover:bg-orange-700',
    confirmText: 'Sí, reingresar',
    onConfirm: async () => {
      procesando.value = true;
      try {
        await reingresarInventarioDevolucion(dev.idDevolucion, usuario?.idUsuario);
        await Promise.all([cargarDevoluciones(), cargarEstadisticas()]);
        toastSuccess('Inventario actualizado', 'Productos reingresados al stock.');
      } catch (error) {
        toastError('Error al reingresar', error.message || 'No se pudo actualizar.');
      } finally { procesando.value = false; }
    }
  });
};

const completarDevolucion = (dev) => {
  abrirConfirm({
    titulo: 'Completar Devolución',
    subtitulo: 'Finalizar proceso',
    mensaje: '¿Marcar como completada?',
    detalle: dev.numero_devolucion,
    icon: 'mdi:check-decagram',
    headerClass: 'bg-gradient-to-r from-indigo-600 to-blue-600',
    subtitleClass: 'text-indigo-100',
    boxClass: 'bg-indigo-50/30 dark:bg-indigo-900/10 border-indigo-100 dark:border-indigo-900/30',
    boxTitleClass: 'text-indigo-700 dark:text-indigo-400',
    btnClass: 'bg-indigo-600 hover:bg-indigo-700',
    confirmText: 'Sí, completar',
    onConfirm: async () => {
      procesando.value = true;
      try {
        await completarDevolucionApi(dev.idDevolucion);
        await Promise.all([cargarDevoluciones(), cargarEstadisticas()]);
        toastSuccess('Devolución completada', dev.numero_devolucion);
      } catch (error) {
        toastError('Error al completar', error.message || 'No se pudo completar.');
      } finally { procesando.value = false; }
    }
  });
};

const abrirModalPago = (dev) => {
  modalPago.value = {
    show: true, devolucion: dev,
    monto_usd: dev.saldo_pendiente_usd,
    monto_bs: dev.saldo_pendiente_bs || 0,
    tasa_bs_usd: dev.tasa_bs_usd || 0,
    metodo_pago: 'efectivo',
    referencia: '',
    observaciones: ''
  };
};
const cerrarModalPago = () => { modalPago.value.show = false; };

const guardarPago = async () => {
  if (modalPago.value.monto_usd <= 0 && modalPago.value.monto_bs <= 0) {
    toastWarning('Monto inválido', 'El monto debe ser mayor a cero.');
    return;
  }
  procesando.value = true;
  try {
    await registrarPagoDevolucion({
      idDevolucion: modalPago.value.devolucion.idDevolucion,
      monto_usd: modalPago.value.monto_usd,
      monto_bs: modalPago.value.monto_bs,
      tasa_bs_usd: modalPago.value.tasa_bs_usd,
      metodo_pago: modalPago.value.metodo_pago,
      referencia: modalPago.value.referencia,
      observaciones: modalPago.value.observaciones,
      idUsuario: usuario?.idUsuario
    });
    cerrarModalPago();
    await Promise.all([cargarDevoluciones(), cargarEstadisticas()]);
    toastSuccess('Pago registrado', 'El pago se guardó correctamente.');
  } catch (error) {
    toastError('Error al registrar pago', error.message || 'No se pudo guardar.');
  } finally { procesando.value = false; }
};

// =====================================================
// FORMATEADORES
// =====================================================
const formatMoney = (v) => Number(v || 0).toFixed(2);
const formatDate = (d) => d ? new Date(d).toLocaleDateString('es-VE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—';
const truncarTexto = (t, l) => !t ? '' : (t.length <= l ? t : t.substring(0, l) + '...');

const formatTipoOrigen = (t) => ({
  venta: '🛒 Venta',
  servicio_externo: '🔧 Serv. Ext.',
  credito_salida_equipo: '📦 Crédito',
  prestamo: '💵 Préstamo',
  compra: '🏭 Compra',
  retencion: '📄 Retención'
}[t] || t || '—');

const formatMotivo = (m) => ({
  producto_defectuoso: 'Producto defectuoso',
  error_cobro: 'Error de cobro',
  servicio_no_realizado: 'Servicio no realizado',
  cliente_arrepentido: 'Cliente arrepentido',
  garantia: 'Garantía',
  sobrepago: 'Sobrepago',
  anulacion: 'Anulación',
  otro: 'Otro'
}[m] || m || '—');

const formatEstado = (e) => ({
  pendiente: 'Pendiente',
  aprobada: 'Aprobada',
  parcial: 'Parcial',
  completada: 'Completada',
  rechazada: 'Rechazada',
  anulada: 'Anulada'
}[e] || e || '—');

onMounted(() => {
  cargarDevoluciones();
  cargarEstadisticas();
});
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }

.custom-scrollbar::-webkit-scrollbar { width: 6px; height: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; }

.dark select option { background-color: #1f2937; color: #ffffff; }

@keyframes zoomIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }

@keyframes fadeInUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
.animate-fadeInUp { animation: fadeInUp 0.4s ease-out forwards; }
.delay-100 { animation-delay: 0.1s; }

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
.animate-fadeIn { animation: fadeIn 0.3s ease-out; }

@keyframes toastProgress { from { width: 100%; } to { width: 0%; } }
@keyframes toastIconBounce {
  0% { transform: scale(0.5) rotate(-10deg); opacity: 0; }
  50% { transform: scale(1.15) rotate(5deg); opacity: 1; }
  100% { transform: scale(1) rotate(0deg); opacity: 1; }
}
.animate-toastIcon { animation: toastIconBounce 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55); }

/* Badges de estado */
.badge-estado {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.estado-pendiente { background: #fff3cd; color: #856404; }
.dark .estado-pendiente { background: rgba(245, 158, 11, 0.2); color: #fcd34d; }
.estado-aprobada { background: #d1e7dd; color: #0a3622; }
.dark .estado-aprobada { background: rgba(16, 185, 129, 0.2); color: #6ee7b7; }
.estado-parcial { background: #cfe2ff; color: #084298; }
.dark .estado-parcial { background: rgba(59, 130, 246, 0.2); color: #93c5fd; }
.estado-completada { background: #d1f7dd; color: #0f5132; }
.dark .estado-completada { background: rgba(16, 185, 129, 0.25); color: #86efac; }
.estado-rechazada { background: #f8d7da; color: #842029; }
.dark .estado-rechazada { background: rgba(239, 68, 68, 0.2); color: #fca5a5; }
.estado-anulada { background: #e2e3e5; color: #41464b; }
.dark .estado-anulada { background: rgba(107, 114, 128, 0.3); color: #d1d5db; }

html { scroll-behavior: smooth; }

@media (max-width: 640px) {
  button { min-height: 36px; }
}
</style>